import { useEffect, useState } from 'react';
import { api } from '../../api.js';
import { Spinner, ErrorNote } from '../../components.jsx';

function fmtWeekday(dateStr) {
  return new Date(`${dateStr}T00:00:00`).toLocaleDateString('en-AU', { weekday: 'short' });
}

function fmtRange(start, end) {
  const fmt = (s) => new Date(`${s}T00:00:00`).toLocaleDateString('en-AU', { day: '2-digit', month: 'short' });
  return `${fmt(start)} – ${fmt(end)}`;
}

// No internal title -- always wrapped by CollapsibleSection, which owns it.
export default function ScheduledJobsWidget() {
  const [weekOffset, setWeekOffset] = useState(0);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [copiedId, setCopiedId] = useState(null);

  useEffect(() => {
    setData(null);
    setError(null);
    api.get(`/api/widgets/scheduled-jobs?weekOffset=${weekOffset}`).then(setData).catch((e) => setError(e.message));
  }, [weekOffset]);

  const copy = (job) => {
    navigator.clipboard.writeText(job.jobNumber).then(() => {
      setCopiedId(job.id);
      setTimeout(() => setCopiedId((id) => (id === job.id ? null : id)), 1500);
    });
  };

  return (
    <div className="card p-4">
      <div className="mb-3 flex items-center justify-between gap-2">
        <div className="flex items-center gap-1">
          <button onClick={() => setWeekOffset((w) => w - 1)} className="rounded-md px-2 py-1 text-steel hover:bg-steel/10" aria-label="Previous week">
            ‹
          </button>
          <span className="min-w-[8rem] text-center text-xs text-steel">{data ? fmtRange(data.weekStart, data.weekEnd) : ' '}</span>
          <button onClick={() => setWeekOffset((w) => w + 1)} className="rounded-md px-2 py-1 text-steel hover:bg-steel/10" aria-label="Next week">
            ›
          </button>
        </div>
        {weekOffset !== 0 && (
          <button onClick={() => setWeekOffset(0)} className="text-xs text-steel underline">
            This week
          </button>
        )}
      </div>

      {error && <ErrorNote>Couldn't reach the scheduler ({error})</ErrorNote>}
      {!data && !error && <Spinner label="Loading jobs…" />}
      {data && data.jobs.length === 0 && <p className="text-sm text-steel">No jobs scheduled this week.</p>}
      {data && data.jobs.length > 0 && (
        <ul className="divide-y divide-steel/10">
          {data.jobs.map((job) => (
            <li key={job.id} className="flex items-center justify-between gap-3 py-2 text-sm">
              <div className="min-w-0">
                <div className="truncate font-medium">{job.jobName || 'No job linked'}</div>
                <div className="truncate text-xs text-steel">{job.dates.map(fmtWeekday).join(', ')}</div>
              </div>
              <div className="shrink-0">
                {job.missingNumber ? (
                  <span className="badge bg-ascred/20 text-ascred">No job #</span>
                ) : (
                  <button onClick={() => copy(job)} className="badge bg-steel/10 text-steel hover:bg-steel/20" title="Copy job number">
                    {copiedId === job.id ? 'Copied!' : job.jobNumber}
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
